<template>
  <div id="app">
    <div id="app">
      <img
        src="./assets/logo.png"
        class="img-fluid pointer mt-2 mb-2"
        alt="Responsive image"
        @click="goToHome"
      >
      <!-- <Menubar/> -->
      <div style="position: sticky;top:0;z-index:100;" id="menubar">
        <div style="background-color:black;display:flex;border-radius:10px;">
          <div style="flex:calc((100% - 50px) / 3);padding:10px;cursor:pointer;">
            <h3 style="user-select:none;color:white;" id="home"
              @click="goToCategory('/')">Início</h3>
          </div>
          <div class="dropdown" name="dropdown" @click="closeMenus($event.target)"
            style="flex:calc((100% - 50px) / 3);padding:10px;cursor:pointer;">
            <h3 style="user-select:none;color:white;">Venda</h3>
            <div class="dropdown-content" style="position:absolute;z-index:1;
              min-width:200px;box-shadow: 0px 8px 16px 0px rgba(0,0,0,0.2);padding: 0px 16px;
              background-color:#f9f9f9;width:calc(100% - 20px);top:68px;">
              <h4 v-for="item in itemsMenuBar[0].items"
                v-bind:style="`background-color:${$router.history.current.path === item.to
                  ? '#FF8000' : ''}`"
                :key="item.label"
                @click="goToCategory(item.to, $event)"
                style="padding:15px 0;margin:0;user-select:none;">{{item.label}}</h4>
            </div>
          </div>
          <div class="dropdown" name="dropdown" @click="closeMenus($event.target)"
            style="flex:calc((100% - 50px) / 3);padding:10px;cursor:pointer;">
            <h3 style="user-select:none;color:white;">Locação</h3>
            <div class="dropdown-content" style="position:absolute;z-index:1;
              min-width:200px;box-shadow: 0px 8px 16px 0px rgba(0,0,0,0.2);padding: 0px 16px;
              background-color:#f9f9f9;width:calc(100% - 20px);top:68px;">
              <h4 v-for="item in itemsMenuBar[1].items"
                v-bind:style="`background-color:${$router.history.current.path === item.to
                  ? '#FF8000' : ''}`"
                :key="item.label"
                @click="goToCategory(item.to, $event)"
                style="padding:15px 0;margin:0;user-select:none;">{{item.label}}</h4>
            </div>
          </div>
          <div style="flex:50px;padding:10px;display:flex;align-items:center;
            justify-content:center;">
            <Button
              v-if="!loggedIn"
              icon="pi pi-user"
              class="p-button-rounded p-button-info"
              @click="showFormlogin"
            />
            <Button
              v-if="loggedIn"
              icon="pi pi-sign-out"
              class="p-button-rounded p-button-info"
              @click="logOutMethod"
            />
          </div>
        </div>
      </div>
      <!-- <body/> -->
      <div class="parent">
        <div class="child-1">
          <router-view v-if="!this.isFetchingProperties"/>
        </div>
        <div class="child-2 ml-2 mr-2">
          <div style="position: sticky; top: 83px;">
          <div class="mt-3 mb-3 cardStick">
            <div class="mt-2 mb-2">
              <p class="card-text">
                <a target="_blank" href="https://api.whatsapp.com/send?phone=554185151965">
                  <img src="./assets/icons/whatsApp.png" height="20">
                  (41) 8515-1965
                </a>
              </p>
              <p class="card-text">
                <img src="./assets/icons/email.png" height="15">
                advmanduri@hotmail.com
              </p>
            </div>
          </div>
            <div
              style="display: flex;
              flex-wrap: wrap;
              flex-direction: row;
              justify-content: center;"
            >
              <h5>Ir para imóvel (Ref.): </h5>
              <input id="inputGoToRef"
                style="width: 50px;
                height: 25px;
                margin-top: auto;
                margin-left: 10px;
                text-align: center;
                margin-bottom: auto;"
                v-model="propertyId"
                @input="goToProperty(false)"
              />
            </div>
            <div v-if="loggedIn" style="display:flex;flex-wrap:wrap;
                flex-direction:row;justify-content:center;">
              <h5 style="margin: auto 10px auto 0;">Modo Edição </h5>
              <CheckboxSwitch
                style="margin:auto 0;"
                :checked="dataManagement"
                @change="setDataManagement($event)"
              ></CheckboxSwitch>
            </div>
            <div v-if="dataManagement" style="height:280px">
              <div style="display:flex;justify-content:center;">
                <h5>Imóveis invisíveis</h5>
                <CheckboxSwitch
                  style="margin-top: auto; margin-bottom: auto; margin-left: 10px;"
                  v-model="showInvisible"
                ></CheckboxSwitch>
              </div>
              <h5>Imóveis em destaque: {{slideShowCount}}</h5>
              <div style="width: 130px; height: 40px; margin: auto;
                margin-top: 16px; margin-bottom: 16px;">
              <button v-if="dataManagement"
                style="width: 150px;;height:60px;"
                class="btnSalvar"
                @click="goToProperty(true)"
              >
                Ir para último imóvel
              </button>
              <br><br><br><br>
              <button v-if="dataManagement"
                id="buttonNewProperty"
                style="width: 150px"
                class="btnSalvar"
                @click="newProperty($event)"
              >
                Novo Imóvel
              </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="card-footer footerPosition">
      <small class="text-muted">Avenida Brasil, 711 - Mandirituba - Paraná CEP 83800-000
      </small>
    </div>
    <FormLogin
      style="z-index:150;"
      :manageVisible="this.manageFormLogin"
    />
  </div>
</template>

<script>
import { mapActions, mapState, mapMutations } from 'vuex';
import CheckboxSwitch from '@/components/checkboxSwitch.vue';
import Button from 'primevue/button';
import FormLogin from '@/components/formLogin.vue';

export default {
  async beforeMount() {
    await this.applySavedToken();
    this.fetchProperties();
    this.fetchCategories();
    document.title = 'Imobiliária Manduri';
  },
  components: {
    CheckboxSwitch,
    Button,
    FormLogin,
  },
  data() {
    return {
      propertyId: null,
      showInvisible: false,
      manageFormLogin: 0,
      mousePressedMenu: false,
    };
  },
  computed: {
    ...mapState('categories', [
      'itemsMenuBar',
      'isFetchingCategories',
      'categories',
    ]),
    ...mapState('properties', [
      'isFetchingProperties',
      'properties',
      'dataManagement',
      'showInvisibleProperties',
      'slideShowCount',
    ]),
    ...mapState('authentication', [
      'loggedIn',
    ]),
  },
  watch: {
    showInvisible: {
      immediate: true,
      deep: true,
      handler(newValue) {
        this.setShowInvisible(newValue);
      },
    },
    showInvisibleProperties: {
      immediate: true,
      deep: true,
      handler(newValue) {
        this.showInvisible = newValue;
      },
    },
  },
  methods: {
    ...mapActions('authentication', ['applySavedToken', 'logOut']),
    ...mapActions('categories', [
      'fetchCategories',
    ]),
    ...mapActions('properties', [
      'fetchProperties',
      'createProperty',
    ]),
    ...mapMutations('properties', [
      'setShowInvisible',
      'setProperty',
      'setDataManagement',
    ]),
    goToProperty(latest = false) {
      let propertyId = 0;
      if (latest) {
        this.properties.forEach((property) => {
          propertyId = Math.max(propertyId, property.id);
        });
      } else {
        propertyId = (this.properties.find((property) => {
          return property.id === parseInt(this.propertyId, 10);
        }) || {}).id;
      }
      if (propertyId) {
        const currentURL = this.$router.history.current.path.split(/\//);
        if (parseInt(currentURL[currentURL.length - 1], 0) !== parseInt(propertyId, 10)) {
          this.$router.push(`/property/${propertyId}`);
        }
      }
    },
    newProperty(event) {
      if (event) event.target.disabled = true;
      this.setProperty({
        subcategory_id: this.categories[0].subcategories[0].id,
        isVisible: false,
      });
      this.createProperty({
        callback: () => {
          if (event) event.target.disabled = false;
        },
      });
    },
    goToHome() {
      const currentURL = this.$router.history.current.path;
      if (currentURL !== '/') this.$router.push('/');
    },
    goToCategory(category, e) {
      const currentURL = this.$router.history.current.path;
      if (currentURL !== category) this.$router.push(category);
      if (e && this.mousePressedMenu) this.closeMenus(e.target.parentElement.parentElement, true);
    },
    closeMenus(target, fromCategory = false) {
      let menu = target.localName === 'div'
        ? target.childNodes[1]
        : target.nextElementSibling;
      if (menu && menu.localName !== 'div') menu = null;
      if (menu) {
        if (menu.style.display === 'none') {
          menu.style.display = 'block';
          document.getElementsByClassName('dropdown-content').forEach((element) => {
            if (element !== menu) element.style.display = 'none';
          });
        } else menu.style.display = 'none';
        if (!fromCategory && !this.mousePressedMenu) {
          this.mousePressedMenu = true;
          this.closeMenus(target);
        }
      }
    },
    showFormlogin() {
      this.manageFormLogin += 1;
    },
    logOutMethod() {
      this.setDataManagement(false);
      this.logOut();
      this.fetchProperties();
    },
    dropdownMenu(event, hide = false) {
      if (event.target.childNodes[1]) {
        event.target.childNodes[1].style.display = hide ? 'none' : 'block';
      }
    },
  },
};
</script>

<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  max-width: 1280px;
  margin: auto;
  min-height: calc(100vh - 46px);
}

#nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}

.parent {
  display: flex;
  flex-direction: column;
}

@media (min-width: 750px) and (orientation:landscape) {
  .parent {
    flex-direction: row;
  }
  .child-1 {
    flex-basis: 100%;
  }
  .child-2 {
    width: 250px;
    min-width: 250px;
  }
}

div.cardStick {
  padding: 5px;
  background-color: #cae8ca;
  border: 2px solid #4CAF50;
}

.dropdown-content {
  display: none;
}

.dropdown:hover .dropdown-content {
  display: block;
}

@media (max-width: 650px) {
  .dropdown-content {
    right: calc((100% - 200px) / 2);
  }
}
</style>
